import s from './style.module.scss';
import { inject, observer } from 'mobx-react';
import ShortAnswer from './ShortAnswer';
import { Display } from '@/components/Display/Display';
import questionImg from '@/assets/images/simulation/question_icon.webp';
import { questionTypeMap } from '@/utils/contants/caseSimulation';
import MultiChoice from './MultiChoice';
import SingelChoice from './SingelChoice';

const AnswerSheet = (props) => {
    const { simulation } = props.store;
    let { curQuestion } = simulation;
    const { question_type } = curQuestion;
    return (
        <>
            <div className={s['answer-sheet-box']}>
                <div className={s['question-title-box']}>
                    <img className={s['question-icon']} src={questionImg} alt="" />
                    <span className={s['question-content']}>{curQuestion?.stem}</span>
                    <Display
                        show={
                            questionTypeMap[question_type] === questionTypeMap.multiple_choice ||
                            questionTypeMap[question_type] === questionTypeMap.multiple_choice_with_input
                        }
                    >
                        <div className={s['question-type-tip']}>(可以选择多个哦～)</div>
                    </Display>
                </div>

                <div className={s['answer-area']}>
                    <Display
                        show={
                            questionTypeMap[question_type] === questionTypeMap.single_choice ||
                            questionTypeMap[question_type] === questionTypeMap.single_choice_with_input
                        }
                    >
                        <SingelChoice></SingelChoice>
                    </Display>
                    <Display
                        show={
                            questionTypeMap[question_type] === questionTypeMap.multiple_choice ||
                            questionTypeMap[question_type] === questionTypeMap.multiple_choice_with_input
                        }
                    >
                        <MultiChoice></MultiChoice>
                    </Display>
                    <Display show={questionTypeMap[question_type] === questionTypeMap.short_answer}>
                        <ShortAnswer></ShortAnswer>
                    </Display>
                </div>
            </div>
        </>
    );
};
export default inject('store')(observer(AnswerSheet));
